import { Table } from 'react-bootstrap'

const RegularSportContent = ({ sectionName }: { sectionName: string }): JSX.Element => (
    <>
        <h5>{sectionName}</h5>
        <p>
            Der Austritt aus einer Sparte/ Abteilung des Niendorfer TSV von 1919 e.V. kann laut Vereinssatzung mit einer
            Frist von einem Monat zum Quartalsende erfolgen.
        </p>
        <Table responsive>
            <tbody>
                <tr>
                    <th>Austritt aus Sparte/ Abtlg. bis zum</th>
                    <th>Wirksam zum</th>
                </tr>
                <tr>
                    <td>28./29. Februar</td>
                    <td>31. März</td>
                </tr>
                <tr>
                    <td>31. Mai</td>
                    <td>30. Juni</td>
                </tr>
                <tr>
                    <td>31. August</td>
                    <td>30. September</td>
                </tr>
                <tr>
                    <td>30. November</td>
                    <td>31. Dezember</td>
                </tr>
            </tbody>
        </Table>
        <p>
            Hiermit bestätige ich den fristgerechten und verbindlichen Austritt aus o.g. Sparte/ Abteilung und ggf.
            enthaltenen Zusatzangeboten. Ich bleibe weiterhin Mitglied im Hauptverein.
        </p>
    </>
)

export default RegularSportContent
